import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-body p-0" }
const _hoisted_2 = { style: {"padding":"24px 27px 0px 27px"} }
const _hoisted_3 = { class: "me-2 flex-grow-1" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"fs-3 mb-2\"><span style=\"color:grey;\">฿ </span><span class=\"fw-boldest\">4,567 </span><button style=\"padding:5px;\" class=\"btn btn-sm btn-light-success fw-boldest\"><i class=\"bi bi-arrow-down\"></i>2.2% </button></div>", 1)
const _hoisted_5 = { class: "pt-7 pb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("customerbills")), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_apexchart, {
          type: "donut",
          width: "250",
          options: _ctx.chartOptions,
          series: _ctx.series
        }, null, 8, ["options", "series"])
      ])
    ])
  ], 2))
}